export default __webpack_public_path__ + "static/media/index.bade3ac3.cjs";